import React from "react";
import {
  Box,
  HStack,
  Skeleton,
  SkeletonText,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";

interface OutboundIpDetailsProps {
  outbound: [key: string] | null;
  isLoading: boolean;
}

export const OutboundIpDetails = ({
  outbound,
  isLoading,
}: OutboundIpDetailsProps) => {
  if (isLoading) {
    return (
      <HStack w="100%">
        <Box width="40%" padding="6" boxShadow="lg">
          <Skeleton height="40px" />
          <SkeletonText mt="4" noOfLines={12} spacing="4" />
        </Box>
        <Box width="60%" padding="6" boxShadow="lg">
          <Skeleton height="40px" />
          <SkeletonText mt="4" noOfLines={12} spacing="4" />
        </Box>
      </HStack>
    );
  }

  return (
    <Table size="sm">
      <Thead>
        <Tr>
          <Th>Field</Th>
          <Th>Value</Th>
        </Tr>
      </Thead>
      <Tbody>
        {Object.entries(outbound!).map(([key, value]) => {
          return (
            <Tr key={key}>
              <Td>{key}</Td>
              <Td>{value}</Td>
            </Tr>
          );
        })}
      </Tbody>
    </Table>
  );
};
